import {component} from '@reduct/component';

import app from '../../assembler';

@component()
class BrowserUpdate {
	constructor() {
		const el = this.getElement();

		if (
			window.Modernizr.svg === false ||
			window.Modernizr.cssanimations === false ||
			!document.body.addEventListener
		) {
			el.style.display = 'block';
		} else {
			el.parentNode.removeChild(el);
		}
	}
}

app.register(BrowserUpdate, 'BrowserUpdate');
